import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../contexts/Web3StatusContext";
import TransactionStatus from '../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class BalanceOfICO extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    inputAddress: null,
    balanceOfDataKey: null,
  };

  componentDidMount() {
    
  }

  componentDidUpdate() {
    
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    const balanceOfDataKey = GAMEFORESTSale.methods[this.props.methodName]
            .cacheCall(this.state.inputAddress);
    this.setState({ balanceOfDataKey: balanceOfDataKey });
  }

  myChangeHandler = (event) => {
    var inputAddress = event.target.value;
    this.setState({inputAddress: inputAddress});
  }

  // destructure drizzle and drizzleState from props
  render() {
    const { drizzle } = this.props;
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    // get the contract state from drizzleState
    var balance = '0';
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;
    var balanceContract = undefined;
    if(this.state.balanceOfDataKey != null) {
        balanceContract = GAMEFORESTSale[this.props.methodName][this.state.balanceOfDataKey];
    }
    if(balanceContract == undefined) {
        balance = <div>0</div>;
    }
    else {
        balance = balanceContract.value;
        console.log('balance2' + balance);
        console.log(drizzle.contracts.GAMEFOREST.address);
    }

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        Address:<br/>
        <input
        onChange={this.myChangeHandler}
        />
        <br/>
        <input
        type='submit'
        value="Get Balance"
        />
        <br/>
        {balance}
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default BalanceOfICO;
